import { ConfigProvider } from 'antd'
import type { ReactNode } from 'react'

import {
  antdTranslationResources,
  availableLanguages,
  type AvailableLanguageType,
  fallbackLng,
} from './resources'
interface AntdLocaleProviderProps {
  children: ReactNode
  language: string
}

export function AntdLocaleProvider({ children, language }: AntdLocaleProviderProps) {
  const localeKey = availableLanguages.includes(language as AvailableLanguageType)
    ? language
    : fallbackLng

  const locale = antdTranslationResources[localeKey as AvailableLanguageType]

  return <ConfigProvider locale={locale}>{children}</ConfigProvider>
}
